(function () {
  'use strict';

  /* ── IntersectionObserver for fade-in animations ──
     Uses CSS classes (which always render) rather than hardcoded IDs.
     This way the page animates regardless of which block-suffix approach was used.
  */

  var animSelectors = [
    '.ba-hero-intro',
    '.ba-text-block',
    '.ba-science-main',
    '.ba-info-card',
    '.ba-format-card',
    '.ba-choose-card',
    '.ba-shop-wrapper',
    '.ba-warning'
  ].join(', ');

  var animTargets = document.querySelectorAll(animSelectors);

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ba-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -8% 0px' });

    animTargets.forEach(function (el) {
      observer.observe(el);
    });

    /* Safety net: after 1 second, force any element still hidden to be visible.
       Handles edge case where IntersectionObserver doesn't fire (e.g. element
       already in viewport when script loads). */
    setTimeout(function () {
      animTargets.forEach(function (el) {
        if (!el.classList.contains('ba-visible')) {
          el.classList.add('ba-visible');
        }
      });
    }, 1200);
  } else {
    /* Fallback for old browsers: show immediately */
    animTargets.forEach(function (el) {
      el.classList.add('ba-visible');
    });
  }

})();
